import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { PrivateRoutes } from "routes/private.routes";
import { PublicRoutes } from "routes/public.routes";
import NotFoundPage from "@pages/public/404";
import { useAppDispatch, useAppSelector } from "@store/hooks";
import { fetchCart, mergeGuestCart } from "@store/cartSlice";

function App() {
  const dispatch = useAppDispatch();
  const token = useAppSelector((state) => state.auth.token);
  const role = useAppSelector((state) => state.auth.user?.role);

  useEffect(() => {
    const loadCart = async () => {
      if (token) {
        const merged = await dispatch(mergeGuestCart());
        if (mergeGuestCart.rejected.match(merged)) {
          dispatch(fetchCart());
        }
        return;
      }
      dispatch(fetchCart());
    };
    loadCart();
  }, [dispatch, token]);

  return (
    <div>
      <BrowserRouter>
        <Routes>
          {PublicRoutes.map((item, key) => {
            // eslint-disable-next-line
            const Element: any = item.component;
            return (
              <Route
                key={key}
                path={item.path}
                element={
                  !token ? (
                    <Element />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
            );
          })}
          {PrivateRoutes.map((item: any, key) => {
            // eslint-disable-next-line
            const Element: any = item.component;
            const superAdmin = role === "admin" || role === "superadmin";
            const allowed = !item.admin || superAdmin || (item.store && role === "store");
            let element = <Element />;
            if (!item.guest) {
              if (!token) {
                element = <Navigate to={`/login?next=${encodeURIComponent(item.path)}`} />;
              } else if (!allowed) {
                element = <Navigate to="/" />;
              }
            }
            return <Route key={key} path={item.path} element={element} />;
          })}
          <Route path={"*"} element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
